import React, { useEffect, useState } from "react";
import { Row, Col, Spin, Card, Typography, Table } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import IntlMessages from "../../../util/IntlMessages";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  getBlockListInProgress,
  getBookedRoomsListInProgress,
  getTotalRoomsListInProgress,
} from "../../../appRedux/Ward/WardAction";
import TableComponent from "../../../components/Table/TableComponent";

const TotalRoomsList = ({ selectedBlockId, onBlockSelect }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState("");

  const bookedRoomData = useSelector((state) => state.ward.totalRoomsList);
  const bookedRoomList = bookedRoomData?.data?.data;
  const handleBlockSelect = (record) => {
    if (onBlockSelect) {
      onBlockSelect(record.id);
    }
  };
  const handleSelectChange = (value) => {
    if (value === "all") {
      setFilteredUsers(bookedRoomList);
    } else {
      const newData = bookedRoomList.slice(0, value);
      setFilteredUsers(newData);
    }
  };
  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Block Name",
      dataIndex: ["Block", "block_name"],
      key: "block_name",
    },
    {
      title: "Ward Name",
      dataIndex: ["Ward", "ward_name"],
      key: "ward_name",
    },

    {
      title: "Room Number",
      dataIndex: "room_number",
      key: "room_number",
    },
    {
      title: "Room Type",
      dataIndex: "room_type",
      key: "room_type",
      render: (text, record) => {
        return record.room_type === "1" ? "AC" : "NON AC";
      },
    },
  ];

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 72,
      }}
      spin
    />
  );

  useEffect(() => {
    if (bookedRoomData?.inProgress) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [bookedRoomData]);

  useEffect(() => {
    const payload = { pagination: "true", pageNo: "1", pageSize: "10" };
    dispatch(getTotalRoomsListInProgress(payload));
  }, [dispatch]);

  return (
    <Card>
      <Row className="p-10 Add-button">
        <Col>
          <Typography className="header-tag">
            {<IntlMessages id={"Addnew.totalRoomList"} />}
          </Typography>
        </Col>
      </Row>
      <Spin indicator={antIcon} spinning={loading}>
        <TableComponent
          columns={columns}
          dataSource={filteredUsers ? filteredUsers : bookedRoomList}
          rowselector={handleSelectChange}
          itemList={bookedRoomList}
          filteredUsers={filteredUsers}
          setFilteredUsers={setFilteredUsers}
          field={"room_no"}
          documentTitle={"Total Room List"}
        />
      </Spin>
    </Card>
  );
};

export default TotalRoomsList;
